import { Box, Button, Modal } from "@mui/material";
import React from "react";
import DropDownComponent from "../DropDownComponent";
import { useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  doc,
  onSnapshot,
  orderBy,
  query,
  setDoc,
} from "firebase/firestore";
import { useEffect } from "react";
import { showCustomToast } from "../Misc/CustomToast";
import { format } from "date-fns";
import AddGeneralLiabilityForm from "../forms/AddGeneralLiabilityForm";
import AddInformedConsentForm from "../forms/AddInformedConsentForm";
import AddPsychiatristServicesForm from "../forms/AddPsychiatristServicesForm";
import AddConfidentialityPolicy from "../forms/AddConfidentialityPolicy";
import AddClientRights from "../forms/AddClientRights";
import AddAgressionControl from "../forms/AddAgressionControl";
import AddDischargeReport from "../forms/AddDischargeReport";
import EditDischargeReport from "../forms/EditDischargeReport";
import AddAcaForm from "../forms/AddAcaForm";
import AddEmergencyDischargeForm from "../forms/AddEmergencyDischargeForm";
import ViewDischargeReport from "../forms/ViewDischargeReport";
import ViewAcaReport from "../forms/ViewAcaReport";
import ViewEmergencyDischargeReport from "../forms/ViewEmergencyDischargeReport";
import InputComponent from "../InputComponent";
import UpdloaderPsychosocialMobile from "../Updloader/UpdloaderPsychosocialMobile";
import UpdloaderTreatmentPlanMobile from "../Updloader/UpdloaderTreatmentPlanMobile";
import AddButtonRoundMobile from "../Buttons/AddButtonRoundMobile";
import UploaderTreatmentPlanModern from "../Updloader/UploaderTreatmentPlanModern";
import UploaderBioPsychoModern from "../Updloader/UploaderBioPsychoModern";
import AddContinuatedTherapySupport from "../forms/AddContinuatedTherapySupport";
import AddBioPsycho3 from "../forms/AddBioPsycho3";
import AddTreatmentPlan from "../forms/AddTreatmentPlan";
import FormLineConsAgreeUnsupervisedMobile from "../Lines/FormLineConsAgreeUnsupervisedMobile";
import AddConsentAgreementUnsupervisedActivityGood from "../forms/AddConsentAgreementUnsupervisedActivityGood";
import FormLineConsAgreeOutingPrivilege from "../Lines/FormLineConsAgreeOutingPrivilege";
import AddConsentSelfOutingPrivilege from "../forms/AddConsentSelfOutingPrivilege";
import Chip from "@mui/material/Chip";
import StandardDrawer from "../forms/StandardDrawer";
import CheckWithDate from "../CheckWithDate";
import "../forms/AdmissionDocumentRedesign.css";
import "./BioPsychoUploadLayout.css";

function ClinicalInformationsMobile(props) {
  const styleModalUploadPdf = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "80%",
    borderRadius: 5,
    backgroundColor: "white",
    boxShadow: 24,
  };

  const styleModalGeneral = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    height: "80%",
    borderRadius: 5,
    // overflowY: "scroll",
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };
  const [isModified, setIsModified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [primaryAddiction, setPrimaryAddiction] = useState(
    props.primaryAddiction || ""
  );
  const [secondaryAddiction, setSecondaryAddiction] = useState(
    props.secondaryAddiction || ""
  );
  const [allergy, setAllergy] = useState(props.allergy || "");
  const [drugAllergy, setDrugAllergy] = useState(props.drugAllergy || "");
  const [currentLegalInvolvement, setCurrentLegalInvolvement] = useState(
    props.currentLegalInvolvement || ""
  );
  const [otherMajorHealthIssues, setOtherMajorHealthIssues] = useState(
    props.otherMajorHealthIssues || ""
  );
  const [primaryAddictionOther, setPrimaryAddictionOther] = useState(
    props.addictionOther || ""
  );
  const [secondaryAddictionOther, setSecondaryAddictionOther] = useState(
    props.secondaryAddictionOther || ""
  );
  const [allergyOther, setAllergyOther] = useState(props.allergyOther || "");
  const [drugAllergyOther, setDrugAllergyOther] = useState(
    props.drugAllergyOther || ""
  );
  const [openUploadBioPsycho2, setOpenUploadBioPsycho2] = useState(false);
  const [openUploadTreatmentPlan, setOpenUploadTreatmentPlan] = useState(false);
  const [openTreatmentPlanForm, setOpenTreatmentPlanForm] = useState(false);
  const [, setTreatmentPlanCreationDate] =
    useState(null);
  const [, setTreatmentPlanCreationBy] = useState("");
  const [, setPresentingIssues] = useState("");
  const [, setLongTermGoals] = useState("");
  const [objectives, setObjectives] = useState([]);
  const [, setReviewDone] = useState(false);
  const [, setReviewDoneAt] = useState(null);
  const [, setReviewDoneBy] = useState("");
  const [openGeneralLiabilityForm, setOpenGeneralLiabilityForm] =
    useState(false);
  const [openInformedConsentForm, setOpenInformedConsentForm] = useState(false);
  const [openPsychiatricServicesForm, setOpenPsychiatricServicesForm] =
    useState(false);
  const [openClientRightsForm, setOpenClientRightsForm] = useState(false);
  const [openAgressionPolicyForm, setOpenAgressionPolicyForm] = useState(false);
  const [openConfidentialityPolicyForm, setOpenConfidentialityPolicyForm] =
    useState(false);
  const [openDischargeSummaryForm, setOpenDischargeSummaryForm] =
    useState(false);
  const [openAcaForm, setOpenAcaForm] = useState(false);
  const [openEmergencyDischargeForm, setOpenEmergencyDischargeForm] =
    useState(false);
  const [openViewDischargeSummaryForm, setOpenViewDischargeSummaryForm] =
    useState(false);
  const [openEditDischargeSummaryForm, setOpenEditDischargeSummaryForm] =
    useState(false);
  const [openViewAcaForm, setOpenViewAcaForm] = useState(false);
  const [openViewEmergencyDischargeForm, setOpenViewEmergencyDischargeForm] =
    useState(false);
  const [dischargeReportOkState, setDischargeReportOkState] = useState(
    props.DischargeReportOk || false
  );
  const [dischargeReportDateState, setDischargeReportDateState] = useState(
    props.DischargeReportDateSigned || null
  );

  const [consentsUnsupervised, setConsentsUnsupervised] = useState([]);
  const [selfOutingPrivileges, setSelfOutingPrivileges] = useState([]);

  const [openAddUnsupervisedMobile, setOpenAddUnsupervisedMobile] =
    useState(false);
  const [openAddSelfOutingMobile, setOpenAddSelfOutingMobile] = useState(false);
  const [bioStatus, setBioStatus] = useState({ label: "Not filled", color: "#d32f2f" });
  useEffect(() => {
    if (!props.clientId) return;
    const unsub = onSnapshot(doc(db, "clients", props.clientId), (snap) => {
      if (snap.exists()) {
        const data = snap.data();
        setDischargeReportOkState(!!data.DischargeReportOk);
        setDischargeReportDateState(data.DischargeReportDateSigned || null);
      }
    });
    return () => unsub();
  }, [props.clientId]);

  const handleCloseBioPsychoForm2 = () => setOpenUploadBioPsycho2(false);
  const handleCloseTreatmentPlan2 = () => setOpenUploadTreatmentPlan(false);
  const [
    openContinuatedTherapySupportForm,
    setOpenContinuatedTherapySupportForm,
  ] = useState(false);

  const handlePrimaryAddictionOther = (event) => {
    setIsModified(true);
    setPrimaryAddictionOther(event);
  };

  const handleSecondaryAddictionOther = (event) => {
    setIsModified(true);
    setSecondaryAddictionOther(event);
  };

  const handleAllergyOther = (event) => {
    setIsModified(true);
    setAllergyOther(event);
  };

  const handlePrimaryAddictionChange = (event) => {
    setIsModified(true);
    setPrimaryAddiction(event);
  };
  const handleSecondaryAddictionChange = (event) => {
    setIsModified(true);
    setSecondaryAddiction(event);
  };
  const handleAllergyChange = (event) => {
    setIsModified(true);
    setAllergy(event);
  };
  const handleDrugAllergyChange = (event) => {
    setIsModified(true);
    setDrugAllergy(event);
  };
  const handleOpenTreatmentPlanForm = () => setOpenTreatmentPlanForm(true);
  const handleCloseTreatmentPlanForm = () => setOpenTreatmentPlanForm(false);
  const handleCloseGeneralLiabilityForm = () =>
    setOpenGeneralLiabilityForm(false);
  const handleCloseInformedConsentForm = () =>
    setOpenInformedConsentForm(false);
  const handleClosePsychiatricServicesForm = () =>
    setOpenPsychiatricServicesForm(false);
  const handleCloseConfidentialityPolicyForm = () =>
    setOpenConfidentialityPolicyForm(false);
  const handleCloseClientRightsForm = () => setOpenClientRightsForm(false);
  const handleCloseAgressionPolicyForm = () =>
    setOpenAgressionPolicyForm(false);
  const handleCloseDischargeSummaryForm = () =>
    setOpenDischargeSummaryForm(false);
  const handleCloseAcaForm = () => setOpenAcaForm(false);
  const handleCloseEmergencyDischargeForm = () =>
    setOpenEmergencyDischargeForm(false);
  const handleCloseViewDischargeSummaryForm = () =>
    setOpenViewDischargeSummaryForm(false);
  const handleCloseEditDischargeSummaryForm = () =>
    setOpenEditDischargeSummaryForm(false);
  const handleCloseViewAcaForm = () => setOpenViewAcaForm(false);
  const handleCloseViewEmergencyDischargeForm = () =>
    setOpenViewEmergencyDischargeForm(false);
  const handleOpenDischargeSummaryForm = () =>
    setOpenDischargeSummaryForm(true);
  const handleOpenAcaForm = () => setOpenAcaForm(true);
  const handleOpenEmergencyDischargeForm = () =>
    setOpenEmergencyDischargeForm(true);
  const handleOpenViewDischargeSummaryForm = () =>
    setOpenViewDischargeSummaryForm(true);
  const handleOpenEditDischargeSummaryForm = () =>
    setOpenEditDischargeSummaryForm(true);
  const handleOpenViewAcaForm = () => setOpenViewAcaForm(true);
  const handleOpenViewEmergencyDischargeForm = () =>
    setOpenViewEmergencyDischargeForm(true);
  const handleCloseContinuatedTherapySupportForm = () =>
    setOpenContinuatedTherapySupportForm(false);

  const [openBioPsycho3, setOpenBioPsycho3] = useState(false);

  const handleOpenBioPsycho3 = () => setOpenBioPsycho3(true);
  const handleCloseBioPsycho3 = () => setOpenBioPsycho3(false);

  //FUNCTIONS

  //Functions clinical data

  const updateClientData = async (clientId) => {
    setIsLoading(true);
    try {
      const clientRef = doc(db, "clients", clientId);
      const clientRefPreAdmission = doc(
        db,
        "preAdmissionAssessments",
        clientId
      );

      await setDoc(
        clientRef,
        {
          primaryAddiction: primaryAddiction,
          secondaryAddiction: secondaryAddiction,
          allergy: allergy,
          drugAllergy: drugAllergy,
          currentLegalInvolvement: currentLegalInvolvement,
          otherMajorHealthIssues: otherMajorHealthIssues,
          primaryAddictionOther: primaryAddictionOther,
          secondaryAddictionOther: secondaryAddictionOther,
          allergyOther: allergyOther,
          drugAllergyOther: drugAllergyOther,
        },
        { merge: true }
      );

      // Ajout de la mise à jour pour clientRefPreAdmission
      await setDoc(
        clientRefPreAdmission,
        {
          primaryAddiction: primaryAddiction,
          addictionOther: primaryAddictionOther,
          secondaryAddiction: secondaryAddiction,
          secondaryAddictionOther: secondaryAddictionOther,
        },
        { merge: true }
      );
      setIsModified(false);

      setIsLoading(false);

      showCustomToast("Clinical informations successfully updated!", "success");
    } catch (error) {
      console.error("Error updating informations: ", error);
      setIsLoading(false);

      showCustomToast(`Error updating informations: ${error}`, "error");
    }
  };

  const fetchTreatmentPlan = (clientId) => {
    const treatmentPlanRef = doc(db, "treatmentPlans", clientId);

    // Écouter les modifications du traitement
    const unsubscribeTreatmentPlan = onSnapshot(
      treatmentPlanRef,
      (treatmentPlanSnap) => {
        if (treatmentPlanSnap.exists()) {
          const treatmentPlanData = treatmentPlanSnap.data();
          setPresentingIssues(treatmentPlanData.presentingIssues);
          setLongTermGoals(treatmentPlanData.longTermGoals);
          setTreatmentPlanCreationDate(treatmentPlanData.createdAt);
          setTreatmentPlanCreationBy(treatmentPlanData.createdBy);
          setReviewDone(treatmentPlanData.reviewDone);
          setReviewDoneAt(treatmentPlanData.reviewDoneAt);
          setReviewDoneBy(treatmentPlanData.reviewDoneBy);
        } else {
          console.error("Treatment plan not found");
          setPresentingIssues("");
          setLongTermGoals("");
          setTreatmentPlanCreationDate(null);
          setTreatmentPlanCreationBy("");
          setReviewDone(false);
          setReviewDoneAt("");
          setReviewDoneBy("");
        }
      },
      (error) => {
        console.error("Error fetching treatment plan:", error);
      }
    );

    // Écouter les modifications des objectifs
    const objectivesRef = collection(treatmentPlanRef, "objectives");
    const unsubscribeObjectives = onSnapshot(
      objectivesRef,
      (objectivesSnapshot) => {
        objectivesSnapshot.forEach((objectiveDoc) => {
          objectives.push({ id: objectiveDoc.id, ...objectiveDoc.data() });
        });

        setObjectives(objectives);
      },
      (error) => {
        console.error("Error fetching objectives:", error);
      }
    );

    // Retourner une fonction de nettoyage pour se désabonner des listeners
    return () => {
      unsubscribeTreatmentPlan();
      unsubscribeObjectives();
    };
  };

  function formatDate(timestamp) {
    if (!timestamp || !timestamp.seconds) return "";

    const milliseconds =
      timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000;
    const date = new Date(milliseconds);

    if (isNaN(date)) return "";

    return format(date, "d MMMM yyyy"); // "d" pour le jour, "MMMM" pour le mois en texte, "yyyy" pour l'année
  }

  const handleDischargeRowKeyDown = (event, handler) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handler();
    }
  };

  const renderDischargeDocumentsHeader = () => (
    <div className="clinical-documents-table-header" aria-hidden="true">
      <div>Name of document</div>
      <div>Signed</div>
      <div>Actions</div>
    </div>
  );

  const renderDischargeDocumentRow = ({
    title,
    signed,
    date,
    onOpen,
    onEdit,
    onAdd,
  }) => (
    <div
      className="clinical-documents-standard-row"
      onClick={signed ? onOpen : onAdd}
      onKeyDown={(event) =>
        handleDischargeRowKeyDown(event, signed ? onOpen : onAdd)
      }
      role="button"
      tabIndex={0}
    >
      <div className="clinical-documents-row-title">{title}</div>
      <div className="clinical-documents-row-signed">
        <CheckWithDate checked={!!signed} content={signed ? date : ""} />
      </div>
      <div className="clinical-documents-row-actions">
        {signed ? (
          <>
            <button
              type="button"
              className="clinical-documents-row-action-button"
              onClick={(event) => {
                event.stopPropagation();
                onOpen();
              }}
            >
              Open / print
            </button>
            {onEdit && (
              <button
                type="button"
                className="clinical-documents-row-action-button clinical-documents-row-edit-button"
                onClick={(event) => {
                  event.stopPropagation();
                  onEdit();
                }}
              >
                Edit
              </button>
            )}
          </>
        ) : (
          <button
            type="button"
            className="clinical-documents-add-button"
            onClick={(event) => {
              event.stopPropagation();
              onAdd();
            }}
            aria-label={`Add ${title}`}
          >
            +
          </button>
        )}
      </div>
    </div>
  );

  //USE EFFECT

  useEffect(() => {
    // Remplacez 'clientId' par l'ID du client pour lequel vous souhaitez récupérer le treatmentPlan
    const unsubscribe = fetchTreatmentPlan(props.clientId);

    // Se désabonner lors du démontage du composant
    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    setPrimaryAddiction(props.primaryAddiction || "");
    setPrimaryAddictionOther(props.addictionOther || "");
    setSecondaryAddiction(props.secondaryAddiction || "");
    setAllergy(props.allergy || "");
    setDrugAllergy(props.drugAllergy || "");
    setCurrentLegalInvolvement(props.currentLegalInvolvement || "");
    setOtherMajorHealthIssues(props.otherMajorHealthIssues || "");
    setSecondaryAddictionOther(props.secondaryAddictionOther || "");
    setDrugAllergyOther(props.drugAllergyOther || "");
    setAllergyOther(props.allergyOther || "");
  }, [
    props.primaryAddiction,
    props.addictionOther,
    props.secondaryAddiction,
    props.allergy,
    props.drugAllergy,
    props.currentLegalInvolvement,
    props.otherMajorHealthIssues,
    props.primaryAddictionOther,
    props.secondaryAddictionOther,
    props.allergyOther,
    props.drugAllergyOther,
  ]);

  useEffect(() => {
    props.onModificationChange(isModified);
  }, [isModified]);

  useEffect(() => {
    if (!props.clientId) return;
    const bioRef = doc(db, "bioPsychoSocialDigitalForm", props.clientId);
    const unsub = onSnapshot(bioRef, (snap) => {
      if (!snap.exists()) {
        setBioStatus({ label: "Not filled", color: "#d32f2f" });
        return;
      }
      const data = snap.data() || {};
      const required = [
        "summary",
        "historyOfSubstanceAbuseProgression",
        "treatmentGoals",
        "motivationIntrinsicFactors",
        "motivationExtrinsicFactors",
      ];
      const isComplete = required.every((k) => {
        const v = data[k];
        return v !== undefined && v !== null && String(v).trim() !== "";
      });
      const hasAny = Object.values(data).some((v) => {
        if (Array.isArray(v)) return v.length > 0;
        return v !== undefined && v !== null && String(v).trim() !== "";
      });
      if (!hasAny) {
        setBioStatus({ label: "Not filled", color: "#d32f2f" });
      } else if (isComplete) {
        setBioStatus({ label: "Complete", color: "#2e7d32" });
      } else {
        setBioStatus({ label: "Partially filled", color: "#f9a825" });
      }
    });
    return () => unsub();
  }, [props.clientId]);

  const [corePlanData, setCorePlanData] = useState(null);

  // à la suite de vos autres useEffect, par exemple
  useEffect(() => {
    const unsubscribeCorePlan = onSnapshot(
      doc(db, "CoreTreatmentPlans", props.clientId),
      (docSnap) => {
        if (docSnap.exists()) {
          setCorePlanData(docSnap.data());
        } else {
          setCorePlanData(null);
        }
      },
      (error) => {
        console.error("Error fetching core treatment plan:", error);
      }
    );

    return () => {
      unsubscribeCorePlan();
    };
  }, [props.clientId]);

  useEffect(() => {
    const colUn = collection(
      db,
      "clients",
      props.clientId,
      "ConsentAgreementUnsupervisedActivities"
    );
    // on trie par signedOn décroissant
    const qUn = query(colUn, orderBy("signedOn", "desc"));
    const unsubUn = onSnapshot(qUn, (snap) =>
      setConsentsUnsupervised(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );

    const colSelf = collection(
      db,
      "clients",
      props.clientId,
      "ConsentSelfOutingPrivileges"
    );
    // idem pour Self-Outing
    const qSelf = query(colSelf, orderBy("signedOn", "desc"));
    const unsubSelf = onSnapshot(qSelf, (snap) =>
      setSelfOutingPrivileges(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );

    return () => {
      unsubUn();
      unsubSelf();
    };
  }, [props.clientId]);

  console.log("contentUnsupervised: ", consentsUnsupervised);

  const handleOpenAddUnsupervisedMobile = () =>
    setOpenAddUnsupervisedMobile(true);
  const handleCloseAddUnsupervisedMobile = () =>
    setOpenAddUnsupervisedMobile(false);
  const handleOpenAddSelfOutingMobile = () => setOpenAddSelfOutingMobile(true);
  const handleCloseAddSelfOutingMobile = () =>
    setOpenAddSelfOutingMobile(false);

  return (
    <div className="tab-container-white-mobile">
      <StandardDrawer
        open={openBioPsycho3}
        onClose={handleCloseBioPsycho3}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddBioPsycho3
          {...props}
          clientId={props.clientId}
          closemodal={handleCloseBioPsycho3}
          dateOfAdmission={props.dateOfAdmission}
        />
      </StandardDrawer>

      <Modal
        open={openTreatmentPlanForm}
        onClose={handleCloseTreatmentPlanForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral}>
          <AddTreatmentPlan
            {...props}
            clientId={props.clientId}
            closemodal={handleCloseTreatmentPlanForm}
            initialData={corePlanData}
          />
        </Box>
      </Modal>

      <Modal
        open={openUploadBioPsycho2}
        onClose={handleCloseBioPsychoForm2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalUploadPdf}>
          <UpdloaderPsychosocialMobile
            {...props}
            closemodal={handleCloseBioPsychoForm2}
          />
        </Box>
      </Modal>

      <Modal
        open={openUploadTreatmentPlan}
        onClose={handleCloseTreatmentPlan2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalUploadPdf}>
          <UpdloaderTreatmentPlanMobile
            {...props}
            closemodal={handleCloseTreatmentPlan2}
          />
        </Box>
      </Modal>

      <Modal
        open={openGeneralLiabilityForm}
        onClose={handleCloseGeneralLiabilityForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral}>
          <AddGeneralLiabilityForm
            closemodal={handleCloseGeneralLiabilityForm}
            clientId={props.clientId}
          />
        </Box>
      </Modal>

      <Modal
        open={openInformedConsentForm}
        onClose={handleCloseInformedConsentForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral}>
          <AddInformedConsentForm
            clientId={props.clientId}
            closemodal={handleCloseInformedConsentForm}
          />
        </Box>
      </Modal>

      <Modal
        open={openPsychiatricServicesForm}
        onClose={handleClosePsychiatricServicesForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral}>
          <AddPsychiatristServicesForm
            closemodal={handleClosePsychiatricServicesForm}
            clientId={props.clientId}
          />
        </Box>
      </Modal>

      <Modal
        open={openConfidentialityPolicyForm}
        onClose={handleCloseConfidentialityPolicyForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral}>
          <AddConfidentialityPolicy
            closemodal={handleCloseConfidentialityPolicyForm}
            clientId={props.clientId}
          />
        </Box>
      </Modal>

      <Modal
        open={openClientRightsForm}
        onClose={handleCloseClientRightsForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral}>
          <AddClientRights
            closemodal={handleCloseClientRightsForm}
            clientId={props.clientId}
          />
        </Box>
      </Modal>

      <Modal
        open={openAgressionPolicyForm}
        onClose={handleCloseAgressionPolicyForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral}>
          <AddAgressionControl
            closemodal={handleCloseAgressionPolicyForm}
            clientId={props.clientId}
          />
        </Box>
      </Modal>

      <StandardDrawer
        open={openDischargeSummaryForm}
        onClose={handleCloseDischargeSummaryForm}
        eyebrow="Clinical form"
        title="Discharge summary / Report"
        subtitle={props.clientName || props.name || "Client"}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddDischargeReport
          clientId={props.clientId}
          closemodal={handleCloseDischargeSummaryForm}
        />
      </StandardDrawer>

      <StandardDrawer
        open={openViewDischargeSummaryForm}
        onClose={handleCloseViewDischargeSummaryForm}
        eyebrow="Clinical form"
        title="Discharge summary / Report"
        subtitle={props.clientName || props.name || "Client"}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <ViewDischargeReport
          clientId={props.clientId}
          closemodal={handleCloseViewDischargeSummaryForm}
        />
      </StandardDrawer>

      <StandardDrawer
        open={openEditDischargeSummaryForm}
        onClose={handleCloseEditDischargeSummaryForm}
        eyebrow="Clinical form"
        title="Discharge summary / Report"
        subtitle={props.clientName || props.name || "Client"}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <EditDischargeReport
          closemodal={handleCloseEditDischargeSummaryForm}
          clientId={props.clientId}
          {...props}
        />
      </StandardDrawer>

      <StandardDrawer
        open={openAcaForm}
        onClose={handleCloseAcaForm}
        eyebrow="Clinical form"
        title="Leave Against Clinical Advice"
        subtitle={props.clientName || props.name || "Client"}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddAcaForm
          closemodal={handleCloseAcaForm}
          clientId={props.clientId}
          {...props}
        />
      </StandardDrawer>

      <StandardDrawer
        open={openViewAcaForm}
        onClose={handleCloseViewAcaForm}
        eyebrow="Clinical form"
        title="Leave Against Clinical Advice"
        subtitle={props.clientName || props.name || "Client"}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <ViewAcaReport
          closemodal={handleCloseViewAcaForm}
          clientId={props.clientId}
          {...props}
        />
      </StandardDrawer>

      <StandardDrawer
        open={openEmergencyDischargeForm}
        onClose={handleCloseEmergencyDischargeForm}
        eyebrow="Clinical form"
        title="Emergency Discharge"
        subtitle={props.clientName || props.name || "Client"}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddEmergencyDischargeForm
          closemodal={handleCloseEmergencyDischargeForm}
          clientId={props.clientId}
          {...props}
        />
      </StandardDrawer>

      <StandardDrawer
        open={openViewEmergencyDischargeForm}
        onClose={handleCloseViewEmergencyDischargeForm}
        eyebrow="Clinical form"
        title="Emergency Discharge"
        subtitle={props.clientName || props.name || "Client"}
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <ViewEmergencyDischargeReport
          closemodal={handleCloseViewEmergencyDischargeForm}
          clientId={props.clientId}
          {...props}
        />
      </StandardDrawer>

      <Modal
        open={openContinuatedTherapySupportForm}
        onClose={handleCloseContinuatedTherapySupportForm}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral}>
          <AddContinuatedTherapySupport
            closemodal={handleCloseContinuatedTherapySupportForm}
            clientId={props.clientId}
          />
        </Box>
      </Modal>

      <StandardDrawer
        // open={openConsentAndAgreementForUnsupervisedActivity}
        // onClose={handleCloseConsentAndAgreementForUnsupervisedActivity}
        open={openAddUnsupervisedMobile}
        onClose={handleCloseAddUnsupervisedMobile}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddConsentAgreementUnsupervisedActivityGood
          // closemodal={handleCloseConsentAndAgreementForUnsupervisedActivity}
          closemodal={handleCloseAddUnsupervisedMobile}
          clientId={props.clientId}
          {...props}
        />
      </StandardDrawer>

      <StandardDrawer
        // open={openSelfOutingPrivilege}
        // onClose={handleCloseSelfOutingPrivilege}
        open={openAddSelfOutingMobile}
        onClose={handleCloseAddSelfOutingMobile}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="admission-document-drawer-paper"
        contentClassName="admission-document-drawer-content"
      >
        <AddConsentSelfOutingPrivilege
          // closemodal={handleCloseSelfOutingPrivilege}
          closemodal={handleCloseAddSelfOutingMobile}
          clientId={props.clientId}
          {...props}
        />
      </StandardDrawer>

      <div className="container-main-plan-mobile-2 clinical-documents-card">
        <div className="tab-container-title">Clinical Information</div>
        <div className="tab-form-container">
          <div className="column-div">
            <DropDownComponent
              api="addictions"
              title="Primary addiction"
              value={primaryAddiction}
              onChange={handlePrimaryAddictionChange}
            />

            {primaryAddiction === "Other" ? (
              <InputComponent
                title="If other, describe"
                width="150px"
                value={primaryAddictionOther}
                onChange={handlePrimaryAddictionOther}
              />
            ) : (
              ""
            )}
          </div>
          <div className="column-div">
            <DropDownComponent
              api="addictions"
              title="Secondary addiction"
              value={secondaryAddiction}
              onChange={handleSecondaryAddictionChange}
            />
            {secondaryAddiction === "Other" ? (
              <InputComponent
                title="If other, describe"
                width="150px"
                value={secondaryAddictionOther}
                onChange={handleSecondaryAddictionOther}
              />
            ) : (
              ""
            )}
          </div>
          <div className="column-div">
            <DropDownComponent
              api="allergies"
              title="Allergy"
              value={allergy}
              onChange={handleAllergyChange}
            />
            {allergy === "Other" ? (
              <InputComponent
                title="If other, describe"
                width="150px"
                value={allergyOther}
                onChange={handleAllergyOther}
              />
            ) : (
              ""
            )}
          </div>

          <div className="column-div">
            <InputComponent
              title="Drug allergy"
              width="150px"
              value={drugAllergy}
              onChange={handleDrugAllergyChange}
            />
          </div>
        </div>
      </div>

      {/* <div className="tab-form-container"> */}
      <div className="container-main-plan-mobile clinical-documents-card">
        {props.dateOfAdmission ? (
          <div className="bio-psycho-upload-layout clinical-document-upload-card">
            <div className="bio-psycho-upload-actions">
              <span className="bio-psycho-upload-label">
                Biopsychosocial assessment
              </span>
              <div>
                <Button variant="contained" onClick={handleOpenBioPsycho3}>
                  OPEN BIOPSYCHOSOCIAL ASSESSMENT
                </Button>
                <Chip
                  label={bioStatus.label}
                  size="medium"
                  sx={{
                    backgroundColor: bioStatus.color,
                    color: "#fff",
                    fontWeight: 700,
                  }}
                />
              </div>
            </div>
            <div className="bio-psycho-upload-panel">
              <UploaderBioPsychoModern {...props} />
            </div>
          </div>
        ) : (
          <div className="error-discharge-message-mobile">
            Unable to add BioPsychosocial & treatment form if the client is not
            admitted.
          </div>
        )}
        {/* </div> */}
      </div>

      <div className="container-main-plan-mobile clinical-documents-card">
        <div className="bio-psycho-upload-layout treatment-plan-upload-layout clinical-document-upload-card">
          <div className="bio-psycho-upload-actions">
            <span className="bio-psycho-upload-label">Treatment plan</span>
            <div>
              <Button variant="contained" onClick={handleOpenTreatmentPlanForm}>
                OPEN TREATMENT PLAN
              </Button>
            </div>
          </div>
          <div className="bio-psycho-upload-panel">
            <UploaderTreatmentPlanModern {...props} />
          </div>
        </div>
      </div>

      <div className="container-main-plan-mobile-bottom clinical-documents-card clinical-documents-consent-card">
        {/* <div className="tab-container-title margin-title">Discharge forms</div> */}
        {props.dateOfAdmission ? (
          <div className="tab-form-container-column clinical-documents-lines clinical-documents-lines-mobile">
            {renderDischargeDocumentsHeader()}

            {renderDischargeDocumentRow({
              title: "Discharge summary / Report",
              signed: dischargeReportOkState,
              date: formatDate(dischargeReportDateState),
              onOpen: handleOpenViewDischargeSummaryForm,
              onEdit: handleOpenEditDischargeSummaryForm,
              onAdd: handleOpenDischargeSummaryForm,
            })}
            {renderDischargeDocumentRow({
              title: "Leave Against Clinical Advice (ACA)",
              signed: props.acaReportOk,
              date: formatDate(props.acaReportDateSigned),
              onOpen: handleOpenViewAcaForm,
              onAdd: handleOpenAcaForm,
            })}
            {renderDischargeDocumentRow({
              title: "Emergency Discharge",
              signed: props.EmergencyDischargeOk,
              date: formatDate(props.EmergencyDischargeDateSigned),
              onOpen: handleOpenViewEmergencyDischargeForm,
              onAdd: handleOpenEmergencyDischargeForm,
            })}

            <div
              style={{
                marginTop: "30px",
                marginBottom: "20px",
                paddingLeft: "20px",
                paddingRight: "20px",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              Consent & Agreement Form for Unsupervised Off-Site Activities
            </div>

            <div className="form-line-button-column-center">
              {consentsUnsupervised.map((item) => (
                <FormLineConsAgreeUnsupervisedMobile
                  key={item.id}
                  id={item.id}
                  clientId={props.clientId}
                  signed={!!item.signedOn}
                  date={formatDate(item.signedOn)}
                  purpose={item.outingPurpose}
                  firstName={props.firstName}
                  lastName={props.lastName}
                />
              ))}
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  margin: "8px 0",
                }}
              >
                <AddButtonRoundMobile
                  handleOpen={handleOpenAddUnsupervisedMobile}
                />
              </div>
            </div>

            <div
              style={{
                marginTop: "30px",
                marginBottom: "20px",
                paddingLeft: "20px",
                paddingRight: "20px",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              Consent & Agreement Form for Self-Outing Privilege
            </div>

            <div className="form-line-button-column-center">
              {selfOutingPrivileges.map((item) => (
                <FormLineConsAgreeOutingPrivilege
                  key={item.id}
                  id={item.id}
                  clientId={props.clientId}
                  signed={!!item.signedOn}
                  date={formatDate(item.signedOn)}
                  purpose={item.outingPurpose}
                  firstName={props.firstName}
                  lastName={props.lastName}
                  // {...props}
                />
              ))}
              <div
                style={{ width: "100%", textAlign: "center", margin: "8px 0" }}
              >
                <AddButtonRoundMobile
                  handleOpen={handleOpenAddSelfOutingMobile}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="error-discharge-message-mobile">
            Unable to sign Discharge form if the client is not admitted.
          </div>
        )}
      </div>

      <div className="button-container-form-gi-mobile">
        <Button
          variant="contained"
          onClick={() => updateClientData(props.clientId)}
          style={
            isModified && !isLoading
              ? {
                  backgroundColor: "red",
                  color: "white",
                  marginLeft: "15px",
                }
              : {
                  backgroundColor: "#1565C0",
                  color: "white",
                  marginLeft: "15px",
                }
          }
          disabled={isLoading}
          sx={{
            height: "40px",
            width: "220px",
            marginLeft: "25px",
            marginRight: "30px",
          }}
        >
          {isLoading
            ? "SAVING MODIFICATIONS..."
            : isModified
            ? "CLICK TO SAVE"
            : "SAVE MODIFICATIONS"}
        </Button>
      </div>
    </div>
  );
}

export default ClinicalInformationsMobile;
